<template>
  <div class="dashboard_container">
    <div class="dashboard_dashboard">Dashboard</div>
    <div class="analytics__container">
      <div class="analytic_icons">
        <div class="analytic_list" v-for="(icon, index) in icons" :key="index">
          <div class="analytic__icons">
            <div>
              <img :src="icon.image" alt="chat" />
            </div>

            <div class="analytic_icon_text">
              {{ icon.text }}
            </div>
          </div>
          <div class="analytics_summ">
            {{ icon.summ }}
          </div>
          <div v-if="icon.month.length" class="analytic_month">
            {{ icon.month }}
          </div>
        </div>
      </div>
    </div>
    <div class="analytic_visit">
      <div class="analytic_visit_text">Most visited link</div>
      <div class="analytic_visit__text">No links clecked yet</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      icons: [
        {
          image: require("@/assets/img/analytic_chat.svg"),
          text: "Total Chat Sessions",
          summ: 1,
          month: "",
        },
        {
          image: require("@/assets/img/analytic_like.svg"),
          text: "Good chat sessions",
          summ: 40,
          month: "",
        },
        {
          image: require("@/assets/img/analytic_dislike.svg"),
          text: "Bad chat sessions",
          summ: 5,
          month: "",
        },
        {
          image: require("@/assets/img/analytic_telegram.svg"),
          text: "Total messages last month",
          summ: 45,
          month: "July 14 - Present",
        },
        {
          image: require("@/assets/img/analytic_telegram.svg"),
          text: "Total messages last month",
          summ: 15,
          month: "August 14 - Present",
        },
        {
          image: require("@/assets/img/analytic_telegram.svg"),
          text: "Total messages last month",
          summ: 5.4,
          month: "",
        },
      ],
    };
  },
};
</script>
<style>
.analytic_icons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 30px 60px;
}
.analytic_icon_text {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.analytic__icons {
  display: flex;
  gap: 6px;
  align-items: center;
}
.analytic_list {
  display: flex;
  padding: 32px;
  border-radius: 8px;
  border: 1px solid #e3e8ef;
  background: #fff;
  flex-direction: column;
  gap: 18px;
}
.analytics_container {
}
.analytics__container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 16px;
}
.analytic_month {
  color: #c4c4c4;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.analytic_visit {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 42px;
}
.analytic_visit_text {
  color: #3e3e3e;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.dashboard_dashboard {
  color: #4f4f4f;
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.analytic_visit__text {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.analytics_summ {
  color: #3e3e3e;
  font-family: "Inter", sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
@media screen and (max-width: 768px) {
  .analytic_icons {
    grid-template-columns: repeat(2, 1fr);
  }
  .analytics_container {
    padding: 37px 20px 0px 20px;
  }
}
@media screen and (max-width: 447px) {
  .analytic_icons {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
